/**
 * Sorts version strings in descending order (newest first)
 * Uses locale-aware comparison with numeric sorting for proper version ordering
 */
export const sortVersionsDescending = (versions: string[]): string[] => {
  return [...versions].sort((a, b) => {
    return b.localeCompare(a, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
};
